import { render, staticRenderFns } from "./StrRiskler.vue?vue&type=template&id=5c920e12"
import script from "./StrRiskler.vue?vue&type=script&lang=js"
export * from "./StrRiskler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports